export const ListTypeEnum = Object.freeze({
    carzelle: 'carzelle',
    partner: 'partner',
    packages: 'packages',
});